import React, { useEffect, useState } from "react"
import { PrimaryButton } from "../components/button/Button"
import useWebometrics from "../api/Webometrics"
import useIniciador from "../api/Iniciador"
import { TextDescription, TextError } from "../components/text/Text"
import Spacer from "../components/Spacer"
import CPFCNPJInput from "../components/input/cpf/CPFCNPJInput"
import { Page } from "../components/page/Page"
import { cpf, cnpj } from 'cpf-cnpj-validator'
import { useSearchParams } from 'react-router-dom'
import styles from './Home.module.css'
import * as DOMPurify from 'dompurify'
import { useConfigs } from "../components/config/Provider"

const Home = () => {
    let [searchParams] = useSearchParams()
    const { sendHomeMetrics, sendLetStartMetrics } = useWebometrics()
    const { iniciar } = useIniciador()
    const [cpfCnpjValue, setCpfCnpjValue] = useState('')
    const [cpfValue, setCpfValue] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [showError, setShowError] = useState(false)
    const token = searchParams.get("token")
    const company = searchParams.get("company")
    const consentId = searchParams.get("consent")
    const configs = useConfigs()
    const [isCnpj, setIsCnpj] = useState()


    useEffect(() => {
        localStorage.setItem("token", token)
        localStorage.setItem("company", company)
        localStorage.setItem("consent", consentId)
    }, [searchParams, token, company, consentId])

    useEffect(() => {
        sendHomeMetrics(company, consentId)
    }, [company, consentId])

    const onChange = ev => {
        setShowError(false)
        const value = ev.target.value.replace(/[.-\D]/g, '')
        if (value.length === 11) {
            if (cpf.isValid(value)) {
                const result = value.match(/.{1,3}/g) ?? []
                setCpfCnpjValue(`${result[0]}.${result[1]}.${result[2]}-${result[3][0]}${result[3][1]}`)
            } else {
                setCpfCnpjValue(value)
            }
        } else if (value.length === 14) {
            if (cnpj.isValid(value)) {
                setIsCnpj(true)
                setCpfCnpjValue(`${value[0]}${value[1]}.${value[2]}${value[3]}${value[4]}.${value[5]}${value[6]}${value[7]}/${value[8]}${value[9]}${value[10]}${value[11]}-${value[12]}${value[13]}`)
                return
            } else {
                setCpfCnpjValue(value)
            }
        } else {
            setCpfCnpjValue(value)
        }
        setIsCnpj(false)
    }

    const onChangeCpf = ev => {
        setShowError(false)
        const value = ev.target.value.replace(/[.-\D]/g, '')
        if (value.length === 11) {
            if (cpf.isValid(value)) {
                const result = value.match(/.{1,3}/g) ?? []
                setCpfValue(`${result[0]}.${result[1]}.${result[2]}-${result[3][0]}${result[3][1]}`)
                return
            }
        }
        setCpfValue(value)
    }

    const onClickNext = async () => {
        if (isCnpj) {
            if (cpf.isValid(cpfValue)) {
                setIsLoading(true)
            } else {
                setShowError(true)
            }
        } else if (cpf.isValid(cpfCnpjValue)) {
            setIsLoading(true)
        } else {
            setShowError(true)
        }

    }

    useEffect(() => {
        if (!isLoading) return
        async function fetchData() {

            const rawCpfCnpj = cpfCnpjValue.replace(/[.-\D]/g, '')
            if (cnpj.isValid(rawCpfCnpj)) {
                const rawCpf = cpfValue.replace(/[.-\D]/g, '')
                const result = await iniciar(rawCpf, rawCpfCnpj, token, company, consentId)
                sendLetStartMetrics(company, { cpf: rawCpf, cnpj: rawCpfCnpj, consentId })
                window.location.href = result.link

            } else if (cpf.isValid(rawCpfCnpj)) {
                const result = await iniciar(rawCpfCnpj, null, token, company, consentId)
                sendLetStartMetrics(company, { cpf: rawCpfCnpj, consentId })
                window.location.href = result.link
            }

        }
        fetchData()
    }, [isLoading, cpfCnpjValue, company, token, iniciar, cpfValue, consentId, sendLetStartMetrics])

    const rawHTML = DOMPurify.sanitize(`${configs.homeScreenText}`)

    return (
        <div>
            <div className={styles.header}>
                <img src={configs.homeScreenUrlImage} className={styles.logo} alt="home-logo" />
            </div>
            <Page>
                <div >
                    {<div dangerouslySetInnerHTML={{ __html: rawHTML }} />}
                </div>

                {!showError && <Spacer height='70px' />}
                {showError && <>
                    {/* <Spacer height='40px' /> */}
                    <TextError>{"CPF ou CNPJ informado inválido, por favor digite novamente"}</TextError>
                    <Spacer height='20px' />
                </>}

                <CPFCNPJInput value={cpfCnpjValue} onChange={onChange} />

                <Spacer height='5px' />

                {isCnpj &&
                    <div style={{ textAlign: 'center' }}>
                        <TextDescription >
                            {'Favor informar o CPF do operador do CNPJ:'}
                        </TextDescription>
                        <CPFCNPJInput text={'CPF:'} value={cpfValue} onChange={onChangeCpf} />
                    </div>
                }

                <Spacer height='20px' />

                <PrimaryButton onClick={onClickNext} isLoading={isLoading}>
                    {'Continuar'}
                </PrimaryButton>

            </Page>
        </div>
    )
}

export default Home